module.exports={
	"Form": "TeamCreateManifest",
	"Scope": "Team-Create",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Team-Create-Identity",
				"Group": "Team-Create-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Team-Create-Details",
				"Group": "Team-Create-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-Create-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-Create-Details",
				"Group": "Team-Create-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
